import React from "react";
import ReactDOM from "react-dom";
import "./css/normalize.css";
import "./index.css";
import arrowsLocation from "./images/Feature_arrows.png";

window.StartAudio=false;


/******************
 Start Loading JSON
*******************/
function loadJSON(callback) {
  var xobj = new XMLHttpRequest();
    xobj.overrideMimeType("application/json");
    xobj.open('GET', 'xml/XML.json', true);
    xobj.onreadystatechange = function () {
    if (xobj.readyState == 4 && xobj.status == "200") {
      //Required use of an anonymous callback as .open will NOT return a value but simply returns undefined in asynchronous mode
      callback(xobj.responseText);
    }
  };
  xobj.send(null);  
}


/*************************
 Start Creating Everything
**************************/
function startCreating(jsonContent, currentFileName, loadAudio) {
  var iPageNumberReact = 0;

  var header = jsonContent[0].header;
  var body = jsonContent[0].maintext;
  var subheader = jsonContent[0].subheader;
  var getStarted = jsonContent[0].getStarted;
  

  /**********************
   Create a step function
  ***********************/
  function Step(props) {
    var iPGNumberM = props.link[props.stepNum.replace("Step", "") - 1];
    return (
      <button className="Step_Button" onClick={props.onClick} id={props.stepNum} onMouseOver={props.onHover} onMouseOut={props.onHoverOut} link={props.link[props.stepNum.replace("Step", "") - 1]}>
        <a href="#" onClick={() => reactClick(iPGNumberM)}>
          <p class="step_title">{[props.stepNum.replace("Step", "")] + "."}</p>
          <p class="step_body">{props.value[props.stepNum.replace("Step", "") - 1]}</p>
          <img src={arrowsLocation} alt="step_arrows" width="27" class="Current_step_arrows" />
        </a>
      </button>
    );
  }


  /*******************************************************************
   Link clicked inside react created content (in Steps or Description)
  ********************************************************************/
  function reactClick(iPGNumberM){
    //console.log("reactClick");
    if(document.getElementById("Steps").classList.contains("titlePage")){
      window.edgeClick(iPGNumberM);
    }
  }


  /***********************
   Create a popup function
  ************************/
  function Popup(props) {
    var popupNumber = Number(props.id.replace("Popup","")) - 1;
    return (
      <div class="popup" id={props.id}>
        <div class="popupBG2">
          <div class="popupBG">
            <p class="Popup_Title">{[props.value[popupNumber]]}</p>
            <div class="outsidePopUp">
              <div class="innerPopUp">
                <p class="Popup_Text">{[props.detail[popupNumber]]}</p>
              </div>
            </div>
            <button class="Close_Button" onClick={props.onClick}>{[props.close]}</button>
          </div>
        </div>
      </div>
    );
  }


  class Screen extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        popups: [],
        steps: [],
        titleText: header,
        descText: body,
        subheader: subheader,
        getStarted: getStarted,
        currentFileName: currentFileName,
        loadAudio: loadAudio,
        play: false
      };
      this.togglePlay = this.togglePlay.bind(this);
    }
    

    /***************************************************************************
     Toggle audio (pause/play) and start/stop animation for marker and scrub bar
    ****************************************************************************/
    togglePlay() {
      var audio = document.getElementById("screenAudio");
      this.setState({ play: !this.state.play });
      
      /*****************************************
       If state is true, play audio. Else, pause
      ******************************************/
      if(this.state.play==true){
        audio.play();
        //document.getElementById("Audio_Marker").style.animationPlayState  = "running";
        //document.getElementById("Audio_Scrub_02").style.animationPlayState  = "running";
        document.getElementById("Audio_Marker").classList.remove("pauseAudio");
        document.getElementById("Audio_Marker").classList.add("playAudio");
        document.getElementById("Audio_Scrub_02").classList.remove("pauseAudio");
        document.getElementById("Audio_Scrub_02").classList.add("playAudio");
      }else{
        audio.pause();
        //document.getElementById("Audio_Marker").style.animationPlayState  = "paused";
        //document.getElementById("Audio_Scrub_02").style.animationPlayState  = "paused";
        document.getElementById("Audio_Marker").classList.remove("playAudio");
        document.getElementById("Audio_Marker").classList.add("pauseAudio");
        document.getElementById("Audio_Scrub_02").classList.remove("playAudio");
        document.getElementById("Audio_Scrub_02").classList.add("pauseAudio");
      }
    }


    /*************************************************************
     when the component is ready, set events for interface buttons
    **************************************************************/
    componentDidMount() {
      //console.log("componentDidMount");
      // add event listener for clicks
      document.getElementById("Next_Button").addEventListener("click", this.changePage, false);
      document.getElementById("rightarrow").addEventListener("click", this.changePage, false);
      document.getElementById("leftarrow").addEventListener("click", this.changePage, false);

      var classname = document.getElementsByClassName("ToC_Target");

      for (var i = 0; i < classname.length; i++) {
        classname[i].addEventListener("click", this.changePage, false);
      }
    }


    /**************************************************************
     when the component is completely removed, not currently needed
    ***************************************************************/
    componentDidUnmount() {
      //console.log("componentDidUnmount");
      // make sure you remove the listener when the component is destroyed
    }


    /***********************
     when the screen changes
    ************************/
    changePage = e => {
    //console.log("/**************************");
    //console.log("NEW SCREEN");
    //console.log("**************************/");
    //if what was clicked was not inactive
    if(e.target.getAttribute("src") !== "images/leftarrow_inactive.gif" && e.target.getAttribute("src") !== "images/rightarrow_inactive.gif"){

      //console.log("changePage enter");
      //reset variables that check to see if screen or audio in react loaded first
      window.StartAudio=false;
      window.reactAudioReady=false;
      
      //add css animation to show loading gif and to hide screen
      document.getElementById("loading").classList.remove("showLoading");
      document.getElementById("loading").classList.remove("hideLoading");
      document.getElementById("loading").classList.add("showLoading");

      //start loading audio and see if it can autoplay
      var audio = document.getElementById("screenAudio");
      audio.load();
      var playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise.then(_ => {
          //console.log("Audio Playing Without Error");
          audio.pause();
          // Automatic playback started!
        })
        .catch(error => {
          //console.log("Audio Play Error");
          // Auto-play was prevented
        });
      }

      document.getElementById("screenAudio").removeEventListener('canplaythrough', addFunctionForAudio);

      //when the audio ended
      audio.addEventListener('ended', function (e) {
        this.setState({ play: true });
        this.togglePlay;
      }.bind(this));

      //reset height for steps
      var numberOfOldSteps = document.getElementById("Steps").getElementsByClassName("Step_Button");
      for(var i=0; i<numberOfOldSteps.length; i++){
        document.getElementById("Steps").getElementsByClassName("Step_Button")[i].style.height="auto";
      }

        var targetTop = e.target;
      //console.log(targetTop);
        //get what was clicked top level containing div to get the id
        if(e.target.id !== "rightarrow" && e.target.id !== "leftarrow" && e.target.id !== "Next_Button" && targetTop.classList==""){
          //console.log("clicked navigation");
          var getTargetLevel;
          var getTargetLevelClass;
            var parentElementVar = ".parentElement";
            if (e.target.id||e.target.classList.contains("ToC_Target")) {
              if(e.target.id !== "getStarted" && e.target.id !== "nextCircle" && e.target.id !== "chevron"){
                targetTop = e.target;
              }else{
                while (!targetTop.classList.contains("getStarted")) {
                  getTargetLevelClass = eval("e.target" + parentElementVar).classList.contains("ToC_Target");
                  targetTop = eval("e.target" + parentElementVar);
                  parentElementVar = parentElementVar + ".parentElement";
                  if(getTargetLevelClass==true){
                    continue;
                  }
                }
              }
            } else {
              while (getTargetLevelClass === undefined || getTargetLevelClass === null || getTargetLevelClass === "") {
                getTargetLevelClass = eval("e.target" + parentElementVar).classList.contains("ToC_Target");
                targetTop = eval("e.target" + parentElementVar);
                parentElementVar = parentElementVar + ".parentElement";
                if(getTargetLevelClass==true){
                  continue;
                }
              }
            }
        }

        //find out what was clicked and choose what screen to go to
        if (targetTop.id === "rightarrow" || targetTop.id === "leftarrow" || document.getElementById("Steps").classList.contains("titlePage") || targetTop.id === "Next_Button" || targetTop.classList.contains("ToC_Target") || targetTop.classList.contains("onScreenLink")) {
          //console.log("clicked one of these - rightarrow leftarrow titlePage Next_Button ToC_Target onScreenLink");
          /*if(targetTop.id === "rightarrow"){
            console.log("clicked - rightarrow");
          }else if(targetTop.id === "leftarrow"){
            console.log("clicked - leftarrow");
          }else if(document.getElementById("Steps").classList.contains("titlePage")){
            console.log("clicked - titlePage");
          }else if(targetTop.id === "Next_Button"){
            console.log("clicked - Next_Button");
          }else if(targetTop.classList.contains("ToC_Target")){
            console.log("clicked - ToC_Target");
          }else if(targetTop.classList.contains("onScreenLink")){
            console.log("clicked - onScreenLink");
          }else{
            console.log("clicked - wait what?");
          }*/
          //reshow menu and navigation buttons
          if (targetTop.id === "Next_Button") {
            document.getElementById("Tab").style.visibility = "visible";
			      document.getElementById("toc_btn").style.visibility = "visible";
			      document.getElementById("leftarrow").style.visibility = "visible";
			      document.getElementById("rightarrow").style.visibility = "visible";
          }
          if (targetTop.id === "rightarrow" || targetTop.id === "Next_Button") {
            iPageNumberReact++;
          } else if (targetTop.id === "leftarrow") {
            iPageNumberReact--;
          }else if(targetTop.classList.contains("ToC_Target")){
            //table of contents or menu clicked
            var iPGNumberM = targetTop.getAttribute('onclick');
            iPGNumberM=iPGNumberM.toString();
            var subTabClickediPGNumberMindexOf = iPGNumberM.indexOf("subTabClicked");
            if(subTabClickediPGNumberMindexOf !== -1){
              var arg=targetTop.id;
              /*
              var myMainSection = arg.substring(0, 1);
              var mySubSection = arg.substring(2, 5);
              if (mySubSection.length == 1) {
                mySubSection = mySubSection + "0";
                var myStartingPage = "10";
              }else{
                var myStartingPage = "11";
                mySubSection = mySubSection.substr(1) + "0";
              }
              var myName = myMainSection + myStartingPage + mySubSection;
              var newPath = "B" + myName + ".html";
              iPGNumberM = newPath;
*/

              var myMainSection = arg.substring(0,1);
              var mySubSection = arg.substring(2,4);
              if(mySubSection.length == 1) {
                mySubSection = mySubSection + "0";
              }
              var myStartingPage = "00";
              var myName = myMainSection + mySubSection + myStartingPage;
              console.log(myName);
              var newPath = "B" + myName + ".html"
              console.log(newPath);
              iPGNumberM = newPath;

            }
            iPGNumberM=iPGNumberM.replace("edgeClick('","");
            iPGNumberM=iPGNumberM.replace("')","");
            iPGNumberM=iPGNumberM.replace("edgeClick(\"","");
            iPGNumberM=iPGNumberM.replace("\")","");

            //console.log("update crumb/link");
            iPageNumberReact=window.arrayPageFileName.indexOf(iPGNumberM);
            window.clickLink(iPageNumberReact);
            window.updateCrumb(iPageNumberReact);
            
            var iframe = document.getElementById("targetframe");
            iframe.src="./slides/"+window.arrayPageFileName[iPageNumberReact];
            if(document.getElementById('tutorialList').style.visibility == 'visible'){
              document.getElementById('tutorialList').style.visibility = 'hidden';
            }
          }else if(targetTop.classList.contains("onScreenLink")){
            var getClasses = targetTop.classList;
            var get2ndClass = getClasses[1];
            var newPath = "B"+get2ndClass+".html";

            iPGNumberM = newPath;
            //console.log("update crumb/link");
            iPageNumberReact=window.arrayPageFileName.indexOf(iPGNumberM);
            window.clickLink(iPageNumberReact);
            window.updateCrumb(iPageNumberReact);
            
            var iframe = document.getElementById("targetframe");
            iframe.src="./slides/"+window.arrayPageFileName[iPageNumberReact];
            if(document.getElementById('tutorialList').style.visibility == 'visible'){
              document.getElementById('tutorialList').style.visibility = 'hidden';
            }
          }else 
          {
            var getTargetLevel;
            var parentElementVar = ".parentElement";
            var targetTop;
            if (e.target.id) {
              targetTop = e.target;
            } else {
              while (getTargetLevel === undefined || getTargetLevel === null || getTargetLevel === "") {
                getTargetLevel = eval("e.target" + parentElementVar + ".id");
                targetTop = eval("e.target" + parentElementVar);
                parentElementVar = parentElementVar + ".parentElement";
              }
            }
            var iPGNumberM = targetTop.getAttribute('link');
            if(iPGNumberM!==undefined&&iPGNumberM!==null){
              iPGNumberM = iPGNumberM+".html";
              //console.log("update crumb/link");
              iPageNumberReact=window.arrayPageFileName.indexOf(iPGNumberM);
              window.clickLink(iPageNumberReact);
              window.updateCrumb(iPageNumberReact);
              
              var iframe = document.getElementById("targetframe");
              iframe.src="./slides/"+window.arrayPageFileName[iPageNumberReact];
              if(document.getElementById('tutorialList').style.visibility == 'visible'){
                document.getElementById('tutorialList').style.visibility = 'hidden';
              }
            }
          }

          var xmlData = jsonContent[iPageNumberReact];
          var fileType = String(xmlData.type);
          currentFileName = xmlData.screen;
          if(fileType == "first"||fileType == "title"){
            loadAudio = xmlData.screen;
          }
          //console.log(currentFileName);

          //remove all classes that were possibly added by previous screen
          document.getElementById("Steps").classList.remove("FirstPage");
          document.getElementById("Steps").classList.remove("titlePage");
          document.getElementById("Steps").classList.remove("stepPage");
          document.getElementById("Steps").classList.remove("popupPage");
          document.getElementById("Steps").classList.remove("popupImagePage");
          document.getElementById("Steps").classList.remove("stepPopupPage");
          document.getElementById("Steps").classList.remove("audioScreenPage");
          
          document.getElementById("subheaderContainer").classList.remove("audioScreenPage");
          document.getElementById("subheaderContainer").classList.remove("FirstPage");

          document.getElementById("Next_Button").classList.remove("audioScreenPage");
          document.getElementById("Next_Button").classList.remove("FirstPage");

          document.getElementById("AudioContainer").classList.remove("FirstPageAudio");
          document.getElementById("AudioContainer").classList.remove("titlePageAudio");
        
          //add class depending on what kind of screen it is
          //console.log("Screen Type = "+fileType+" screen");
          if(fileType == "audioScreen"){
            document.getElementById("Steps").classList.add("audioScreenPage");
            document.getElementById("Next_Button").classList.remove("hidden");
            document.getElementById("Next_Button").classList.add("audioScreenPage");
            document.getElementById("subheaderContainer").classList.remove("hidden");
            document.getElementById("subheaderContainer").classList.add("audioScreenPage");
            document.getElementById("Next_Button").setAttribute("link","B00010");
          }
          if (fileType == "first") {
            document.getElementById("Steps").classList.add("FirstPage");
            document.getElementById("AudioContainer").classList.add("FirstPageAudio");
            document.getElementById("Next_Button").classList.remove("hidden");
            document.getElementById("Next_Button").classList.add("FirstPage");
            document.getElementById("subheaderContainer").classList.remove("hidden");
            document.getElementById("subheaderContainer").classList.add("FirstPage");
            document.getElementById("Next_Button").setAttribute("link","B11000");
          }
          if (fileType == "title") {
            document.getElementById("Steps").classList.add("titlePage");
            document.getElementById("AudioContainer").classList.add("titlePageAudio");
            if(!document.getElementById("Next_Button").classList.contains("hidden")){
              document.getElementById("Next_Button").classList.add("hidden");
              document.getElementById("subheaderContainer").classList.add("hidden");
            }
          }
          if (fileType == "step") {
            document.getElementById("Steps").classList.add("stepPage");
            if(!document.getElementById("Next_Button").classList.contains("hidden")){
              document.getElementById("Next_Button").classList.add("hidden");
              document.getElementById("subheaderContainer").classList.add("hidden");
            }
          }
          if (fileType == "popup") {
            document.getElementById("Steps").classList.add("popupPage");
            if(!document.getElementById("Next_Button").classList.contains("hidden")){
              document.getElementById("Next_Button").classList.add("hidden");
              document.getElementById("subheaderContainer").classList.add("hidden");
            }
          }
          if (fileType == "stepPopup") {
            document.getElementById("Steps").classList.add("stepPopupPage");
            if(!document.getElementById("Next_Button").classList.contains("hidden")){
              document.getElementById("Next_Button").classList.add("hidden");
              document.getElementById("subheaderContainer").classList.add("hidden");
            }
          }
          if (fileType == "popupImage") {
            document.getElementById("Steps").classList.add("popupImagePage");
            if(!document.getElementById("Next_Button").classList.contains("hidden")){
              document.getElementById("Next_Button").classList.add("hidden");
              document.getElementById("subheaderContainer").classList.add("hidden");
            }
          }

          //reset height for steps container
          if(document.getElementById("Steps").classList.contains("FirstPage") || document.getElementById("Steps").classList.contains("titlePage")){
            document.getElementById("Steps").style.height = "405px";
          }else{
            document.getElementById("Steps").style.height = "458px";
          }
      
          var header = String(xmlData.header);
          var body = String(xmlData.maintext);
          var subheader = String(xmlData.subheader);
          var getStarted = String(xmlData.getStarted);

          //if the screen has a clickable button/link in the left side react content
          if (fileType == "step" || fileType == "title" || fileType == "stepPopup") {
            var stepI = 1;
            while (xmlData.content[stepI]!==undefined){
              stepI++;
            }
            var lengthofSteps = stepI;
            var NumberOfSteps = [];
            
            //if title screen, start counting at 0, else start at 1 for step1
            if(fileType == "title"){
              var NumberOfStepsI = 0;
            }else{
              var NumberOfStepsI = 1;
            }
            
            while (NumberOfStepsI < lengthofSteps) {
              NumberOfSteps.push(NumberOfStepsI);
              NumberOfStepsI++;
            }

            var steps = xmlData.content;
            var TextOnlyI = 0;
            var stepLink=[];
            var stepsTextOnly=[];
            
            while(TextOnlyI<lengthofSteps){
              //if title screen, add link
              if(fileType == "title"){
                stepsTextOnly.push(steps[TextOnlyI].title);
                stepLink.push(steps[TextOnlyI].link);
              }else if(fileType == "stepPopup"){
                if(TextOnlyI<lengthofSteps-1){
                  stepsTextOnly.push(steps[TextOnlyI+1].step);
                }
              }else{
                stepsTextOnly.push(steps[TextOnlyI+1]);
              }
              TextOnlyI++;
            }
            if(fileType == "title"){
              lengthofSteps++;
            }
          } // end if step / title / stepPopup

          //if popups are needed
          if (fileType == "popup" || fileType == "stepPopup" || fileType == "popupImage") {
            var popupI = 1;
            while (xmlData.content[popupI]!==undefined){
              popupI++;
            }

            var lengthofPopups = popupI;
            var NumberOfPopups = [];
            var NumberOfPopupsI = 1;
            while (NumberOfPopupsI < lengthofPopups) {
              NumberOfPopups.push(NumberOfPopupsI);
              NumberOfPopupsI++;
            }
            window.checkHotspots = new Array(NumberOfPopupsI-1);
            var Popups = xmlData.content;

            var TextOnlyI = 1;
            var PopupsTextOnly=[];
            var PopupsDetailTextOnly=[];
            while(TextOnlyI<lengthofPopups){
              PopupsTextOnly.push(Popups[TextOnlyI].btn);
              PopupsDetailTextOnly.push(Popups[TextOnlyI].detail);
              TextOnlyI++;
            }
            var PopupsArray = [Popups];
            PopupsArray.push(NumberOfPopups);
            var closebutton = xmlData.closebutton;
          } // rnf ig popup / stepPopup / popupImage


          //if this is a step screen, but not a step and popup screen
          if(document.getElementById("Steps").classList.contains("stepPage") || document.getElementById("Steps").classList.contains("titlePage")){
            this.setState({
              popups: [],
              steps: [],
              titleText: header,
              descText: body,
              subheader: subheader,
              getStarted: getStarted,
              currentFileName: currentFileName,
              loadAudio: loadAudio,
              play: false
            });
            this.setState({
              popups: [],
              steps: this.renderStep(stepsTextOnly, lengthofSteps, stepLink),
              titleText: header,
              descText: body,
              subheader: subheader,
              getStarted: getStarted,
              currentFileName: currentFileName,
              loadAudio: loadAudio,
              play: false
            });
          }else if(document.getElementById("Steps").classList.contains("popupPage")||document.getElementById("Steps").classList.contains("popupImagePage")){
            this.setState({
              popups: [],
              steps: [],
              titleText: header,
              descText: body,
              subheader: subheader,
              getStarted: getStarted,
              currentFileName: currentFileName,
              loadAudio: loadAudio,
              play: false
            });
            //if this is a popup screen, with no steps
            this.setState({
              popups: []
            });
            this.setState({
              popups: this.renderPopup(PopupsTextOnly, PopupsDetailTextOnly, closebutton, lengthofPopups),
              steps: [],
              titleText: header,
              descText: body,
              subheader: subheader,
              getStarted: getStarted,
              currentFileName: currentFileName,
              loadAudio: loadAudio,
              play: false
            });
          }
          //if this is a stepPopup screen (need steps and popups)
          else if(document.getElementById("Steps").classList.contains("stepPopupPage")){
            this.setState({
              popups: [],
              steps: [],
              titleText: header,
              descText: body,
              subheader: subheader,
              getStarted: getStarted,
              currentFileName: currentFileName,
              loadAudio: loadAudio,
              play: false
            });
            this.setState({
              popups: this.renderPopup(PopupsTextOnly, PopupsDetailTextOnly, closebutton, lengthofPopups),
              steps: this.renderStep(stepsTextOnly, lengthofSteps, stepLink),
              titleText: header,
              descText: body,
              subheader: subheader,
              getStarted: getStarted,
              currentFileName: currentFileName,
              loadAudio: loadAudio,
              play: false
            });
          } else {
            //if this is the start screen or unknown screen.
            this.setState({
              popups: [],
              steps: [],
              titleText: header,
              descText: body,
              subheader: subheader,
              getStarted: getStarted,
              currentFileName: currentFileName,
              loadAudio: loadAudio,
              play: false
            });
          }

          //if title screen, add event listener to each step to change page
          if(document.getElementById("Steps").classList.contains("titlePage")){
            var iNum = 1;
            var updateINum = "Step1";
            while (document.getElementById(updateINum)) {
              document.getElementById(updateINum).addEventListener("click", this.changePage, false);
              iNum++;
              updateINum = "Step" + iNum;
            }
          }else{
            var iNum = 1;
            var updateINum = "Step1";
            while (document.getElementById(updateINum)) {
              document.getElementById(updateINum).removeEventListener("click", this.changePage, false);
              iNum++;
              updateINum = "Step" + iNum;
            }
          }

          //reset screen
          resetText(this.changePage);
        }

        window.reactjsCurrentScreen = currentFileName;
        //console.log("react updated to "+currentFileName);
        window.reactCurrentScreenLoaded = currentFileName;
        //console.log("window.reactjsCurrentScreen = "+window.reactjsCurrentScreen);
        //console.log("inside Javascript");
        //console.log("react updated to = "+window.reactCurrentScreenLoaded);
        if(window.animateCurrentScreenLoaded == window.reactCurrentScreenLoaded){
          //console.log("screen match - index.js");
        }else{
          //console.log("screen doesn't match - index.js");
        }

        //reset audio marker and scrub bar
        document.getElementById("Audio_Marker").style.animation = '';
        document.getElementById("Audio_Scrub_02").style.animation = '';
        document.getElementById("Audio_Scrub_02").style.width = "1px";
        document.getElementById("Audio_Marker").style.left = "51px";
        document.getElementById("Audio_Marker").style.animation = 'none';
        document.getElementById("Audio_Scrub_02").style.animation = 'none';
      }//end if what was clicked was not inactive
    }; //end changePage


    //step clicked
    handleClick(e) {
      //if step clicked was on a title screen, do nothing (that is handled by the changePage function)
      if(document.getElementById("Steps").classList.contains("titlePage")){
        
      }else{
        var iNum = 1;
        var updateINum = "Step1";
        while (document.getElementById(updateINum)) {
          iNum++;
          updateINum = "Step" + iNum;
        }
        var getTargetLevel;
        var parentElementVar = ".parentElement";
        var targetTop;
        if (e.target.id) {
          targetTop = e.target;
        } else {
          while (getTargetLevel === undefined || getTargetLevel === null || getTargetLevel === "") {
            getTargetLevel = eval("e.target" + parentElementVar + ".id");
            targetTop = eval("e.target" + parentElementVar);
            parentElementVar = parentElementVar + ".parentElement";
          }
        }

        //jump to step clicked inside animate canvas
        window.parent.jumpTo(targetTop.id);
      }
    }


    //if user hovers over title page step, move arrow
    handleHover(e) {
      if(document.getElementById("Steps").classList.contains("titlePage")){
        var getTargetLevel;
        var parentElementVar = ".parentElement";
        var targetTop;
        if (e.target.id) {
          targetTop = e.target;
        } else {
          while (getTargetLevel === undefined || getTargetLevel === null || getTargetLevel === "") {
            getTargetLevel = eval("e.target" + parentElementVar + ".id");
            targetTop = eval("e.target" + parentElementVar);
            parentElementVar = parentElementVar + parentElementVar;
          }
        }
        var StepTargetTopId = targetTop.id.indexOf("Step");
        if(StepTargetTopId !== -1){
          document.getElementById(targetTop.id).getElementsByClassName("Current_step_arrows")[0].classList.add("moveArrow");
        }
      }
    }


    //if user hovers off title page step, move arrow back
    handleHoverOut(e) {
      if(document.getElementById("Steps").classList.contains("titlePage")){
        var getTargetLevel;
        var parentElementVar = ".parentElement";
        var targetTop;
        if (e.target.id) {
          targetTop = e.target;
        } else {
          while (getTargetLevel === undefined || getTargetLevel === null || getTargetLevel === "") {
            getTargetLevel = eval("e.target" + parentElementVar + ".id");
            targetTop = eval("e.target" + parentElementVar);
            parentElementVar = parentElementVar + parentElementVar;
          }
        }
        var indexOfTargetTopId = targetTop.id.indexOf("Step");
        if(indexOfTargetTopId !== -1){
          document.getElementById(targetTop.id).getElementsByClassName("Current_step_arrows")[0].classList.remove("moveArrow");
        }
      }
    }


    //if popup close button clicked
    handlePopClick(e) {
      var iNum = 1;
      var updateINum = "Popup1";
      while (document.getElementById(updateINum)) {
          iNum++;
          updateINum = "Popup" + iNum;
      }

      for (var i = 1; i < iNum; i++) {
          updateINum = "Popup" + i;
          if (document.getElementById(updateINum)) {
              if(!document.getElementById(updateINum).classList.contains("hidePopup")){
                  document.getElementById(updateINum).classList.add("hidePopup");
              }            
          }
      }
      //if popupImagePage screen, jump back to start
      if(document.getElementById("Steps").classList.contains("popupImagePage")||document.getElementById("Steps").classList.contains("stepPopupPage")){
        window.popUpCloseButtonClicked();
      }
    }


    //start creating steps
    renderStep(stepsTextOnly, lengthofSteps, stepLink) {
      var createSteps = [];
      var clickI;
      for (var i = 1; i < lengthofSteps; i++) {
        clickI = i;
        createSteps.push(
          <Step
            key={"Step" + i}
            stepNum={"Step" + i}
            value={stepsTextOnly}
            id={"Step" + clickI}
            link={stepLink}
            onClick={this.handleClick.bind(this)}
            onHover={this.handleHover.bind(this)}
            onHoverOut={this.handleHoverOut.bind(this)}
          />
        );
      }
      return createSteps;
    }

    //start creating popups
    renderPopup(PopupsTextOnly, PopupsDetail, closebutton, lengthofPopups) {
      var createPopup = [];
      var clickI;
      for (var i = 1; i < lengthofPopups; i++) {
        clickI = i;

        createPopup.push(
          <Popup
            key={"Popup" + i}
            stepNum={"Popup" + i}
            value={PopupsTextOnly}
            detail={PopupsDetail}
            close={closebutton}
            id={"Popup" + clickI}
            onClick={this.handlePopClick.bind(this)}
          />
        );
      }
      return createPopup;
    }

    //render the screen
    render() {
      return [
        <div id="loading" class="hideLoading"><img id="loadingImage" src="images/loading.gif"></img></div>,
        this.state.popups,
        <div id="Steps" className="Steps audioScreenPage" key="Steps">
          <div id="innerSteps" className="innerSteps">
            <p id="Main_Title">{this.state.titleText}</p>
            <p id="Main_Body">{this.state.descText}</p>
            {this.state.steps}
          </div>
        </div>,
        <div id="subheaderContainer" class="subheader audioScreenPage" key="subheaderContainer">
          <p id="subheader">{this.state.subheader}</p>
        </div>,
        <div id="Next_Button" class="getStarted audioScreenPage" key="Next_Button" link="B00010" onClick={() => window.nextPage(window.iPageNumber)}>
          <p id="getStarted">{this.state.getStarted}</p>
          <div id="nextCircle">
              <div id="chevron"></div>
          </div>
        </div>,
        <div id="AudioContainer" className="Audio AudioContainer FirstPageAudio hidden" key="AudioContainer">
          <audio id="screenAudio" className="Audio hidden" key="audio" preload="auto" autoplay="true" duration={this.state.duration}>
            <source src={"sounds/"+this.state.loadAudio+".mp3"} type="audio/mpeg"/>
            <source src={"sounds/"+this.state.loadAudio+".ogg"} type="audio/ogg"/>
          </audio>
          <img id="Play_Button" className="Audio hidden" src={this.state.play ? 'images/Audio_play.png' : 'images/Audio_pause.png'} onClick={this.togglePlay}></img>
          <div id="Audio_Marker" className="Audio hidden"></div>
          <div id="Audio_Scrub_01" className="Audio hidden"></div>
          <div id="Audio_Scrub_02" className="Audio hidden"></div>
          <div id="Audio_Background" className="Audio hidden"></div>
        </div>
      ];
    }
  } //end of - class Screen extends React.Component

  ReactDOM.render(<Screen />, document.getElementById("root"));

  resetText();
}//end startCreating




/***************************************
keeping just in case
this should get the position of anything
****************************************/
function getPosition(el) {
  var xPos = 0;
  var yPos = 0;
  while (el) {
    if (el.tagName == "BODY") {
      // deal with browser quirks with body/window/document and page scroll
      var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
      var yScroll = el.scrollTop || document.documentElement.scrollTop;
      xPos += el.offsetLeft - xScroll + el.clientLeft;
      yPos += el.offsetTop - yScroll + el.clientTop;
    } else {
      // for all other non-BODY elements
      xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
      yPos += el.offsetTop - el.scrollTop + el.clientTop;
    }
    el = el.offsetParent;
  }
  var finalPos = [xPos, yPos];

  return finalPos;
}




//reset text after screen change
function resetText(e) {
  //console.log("resetText enter");
  /***************
   Reset Audio Bar
  ****************/
  var audioI=0;
  //if this is a screen that needs audio show it, else hide it
  if(document.getElementById("Steps").classList.contains("FirstPage") || document.getElementById("Steps").classList.contains("titlePage")){
    var audioLength = document.getElementsByClassName("Audio").length;
    while(audioI<audioLength){
      document.getElementsByClassName("Audio")[audioI].classList.remove("hidden");
      audioI++;
    }

    /*If audio can play through*/
    document.getElementById("screenAudio").addEventListener('canplaythrough', addFunctionForAudio, false);
  }else{
    var audioLength = document.getElementsByClassName("Audio").length;
    while(audioI<audioLength){
      document.getElementsByClassName("Audio")[audioI].classList.add("hidden");
      audioI++;
    }
  }
  //remove logo for first 2 screens
  if(document.getElementById("Steps").classList.contains("audioScreenPage")){
    document.getElementById("Logo").classList.add("LogoHide");
  }else{
    document.getElementById("Logo").classList.remove("LogoHide");
  }
  

  /********************************************
   Reset Scrollbar and make sure text uses html
  *********************************************/
  const container = document.querySelector('#Steps');
  container.scrollTop = 0;

  var resetTitle = document.getElementById("Main_Title").textContent;
  document.getElementById("Main_Title").innerHTML = resetTitle;

  var resetBody = document.getElementById("Main_Body").textContent;
  document.getElementById("Main_Body").innerHTML = resetBody;

  if(document.getElementById("Steps").style.height == ""){
    document.getElementById("Steps").style.height = "173px";
  }
  if(document.getElementById("innerSteps").style.height == ""){
    document.getElementById("innerSteps").style.height = "170px";
  }
  /***************************
   If steps exist, reset them
  ****************************/
  if(document.getElementById("Step1")){
    var resetButtonTitle;
    var resetButtonBody;

    var iNum = 1;
    var updateINum = "Step1";
    while (document.getElementById(updateINum)) {
      document.getElementById(updateINum).style.opacity = 1;
      iNum++;
      updateINum = "Step" + iNum;
    }

    for (var i = 1; i < iNum; i++) {
      resetButtonTitle = document.getElementById("Step" + i).getElementsByClassName("step_title")[0].textContent;
      resetButtonBody = document.getElementById("Step" + i).getElementsByClassName("step_body")[0].textContent;
      document.getElementById("Step" + i).getElementsByClassName("step_title")[0].innerHTML = resetButtonTitle;
      document.getElementById("Step" + i).getElementsByClassName("step_body")[0].innerHTML = resetButtonBody;

      if (i !== 1 || document.getElementById("Steps").classList.contains("stepPopupPage")) {
        document.getElementById("Step" + i).style.backgroundColor = "#f2f2f2";
        document.getElementById("Step" + i).getElementsByClassName("Current_step_arrows")[0].style.opacity = 0;
      } else {
        document.getElementById("Step" + i).style.backgroundColor = "#e4e4e4";
        document.getElementById("Step" + i).getElementsByClassName("Current_step_arrows")[0].style.opacity = 1;
      }
      if(document.getElementById("Steps").classList.contains("titlePage")){
        document.getElementById("Step" + i).style.backgroundColor = "#f2f2f2";
        document.getElementById("Step" + i).getElementsByClassName("Current_step_arrows")[0].style.opacity = 1;
      }
    }

    //manually set top and height
    var i = 1;
    var getlastChild = Number(document.getElementById("innerSteps").lastChild.id.replace("Step", ""));
    while (i < getlastChild + 1) {
      var stepStats = document.getElementById("Step" + i).getBoundingClientRect();
      var stepTop = stepStats.y;
      var stepHeight = stepStats.height;
      document.getElementById("Step" + i).style.top = Number(stepTop) - 125 + "px";
      document.getElementById("Step" + i).style.height = stepHeight + "px";
      i++;
    }
  }



  /***************************
   If popups exist, reset them
  ****************************/
  if(document.getElementById("Popup1")){
    var iNum = 1;
    var updateINum = "Popup1";
    while (document.getElementById(updateINum)) {
      iNum++;
      updateINum = "Popup" + iNum;
    }
    var resetButtonTitle = null;
    var resetButtonBody = null;
    for (var i = 1; i < iNum; i++) {
      //show popup
      document.getElementById("Popup" + i).classList.remove("hidePopup");
      var outsidePopUp = document.getElementById("Popup" + i).getElementsByClassName("outsidePopUp")[0];
      var innerPopup = document.getElementById("Popup" + i).getElementsByClassName("innerPopUp")[0];
      var popupText = document.getElementById("Popup" + i).getElementsByClassName("Popup_Text")[0];

      //set text
      resetButtonTitle = document.getElementById("Popup" + i).getElementsByClassName("Popup_Title")[0].textContent;
      resetButtonBody = document.getElementById("Popup" + i).getElementsByClassName("Popup_Text")[0].textContent;
      document.getElementById("Popup" + i).getElementsByClassName("Popup_Title")[0].innerHTML = resetButtonTitle;
      document.getElementById("Popup" + i).getElementsByClassName("Popup_Text")[0].innerHTML = resetButtonBody;
      
      outsidePopUp.style.height = "236px";

      var PopupTitleHeight = document.getElementById("Popup" + i).getElementsByClassName("Popup_Title")[0].getBoundingClientRect().height;

      if(Number(PopupTitleHeight)>60){
        outsidePopUp.style.height = "203px";
      }else if(Number(PopupTitleHeight)>40 && Number(PopupTitleHeight)<59){
        outsidePopUp.style.height = "225px";
      }
      innerPopup.style.height = popupText.scrollHeight;

      //see if scrollbar needed
      if(popupText.scrollHeight>outsidePopUp.getBoundingClientRect().height){
        var currentPopup = document.getElementById("Popup" + i);
        window.parent.addScrollbarForPopup(currentPopup);
      }else{
        document.getElementById("Popup" + i).getElementsByClassName("outsidePopUp")[0].style.overflow = "hidden";
      }
      //re-hide all popups
      document.getElementById("Popup" + i).classList.add("hidePopup");
    }
  }



  /*******************************************
   Resize innerSteps div, based on last object
  ********************************************/
  if(document.getElementById("Steps").classList.contains("audioScreenPage")){
    var correctingHeight = 250;
  }else{
    var correctingHeight = 150;
  }
  var getPositionOfLastChild = document.getElementById("innerSteps").lastChild.getBoundingClientRect().top - correctingHeight;
  var getHeightOfLastChild = document.getElementById("innerSteps").lastChild.getBoundingClientRect().height;
  if(document.getElementById("Steps").classList.contains("titlePage")){
    var changeHeightOfInnerSteps = Number(getPositionOfLastChild) + Number(getHeightOfLastChild);
  }else{
    var changeHeightOfInnerSteps = Number(getPositionOfLastChild) + Number(getHeightOfLastChild) + 10;
  }
  document.getElementById("innerSteps").style.height = changeHeightOfInnerSteps + "px";

  window.parent.addScrollbar(changeHeightOfInnerSteps);



  /************************************
  If link in text, add event listener
  *************************************/
  var onScreenLinkVar = document.getElementsByClassName("onScreenLink");
  for (var i = 0; i < onScreenLinkVar.length; i++) {
    onScreenLinkVar[i].addEventListener("click", e, false);
  }
} /*End of "resetText" function*/



function addFunctionForAudio() {
  var audio = document.getElementById("screenAudio");
  //console.log(audio);
  //console.log("audio should pause");
  audio.pause();
  var audioSource = audio.getElementsByTagName("source")[0].src.slice(-10);
  var currentFileName = audioSource.substring(0, audioSource.length - 4);
  var loadAudio = audioSource.substring(0, audioSource.length - 4);

  //get duration of audio to know how long it is
  var duration = audio.duration;
  window.newDuration = String(duration).replace(".", "");
  duration = String(duration);

  //if there are more than 3 numbers after the period (12.5324 seconds)
  if(String(duration).split('.')[1].length>3) {
    var onlyFirstThree = String(duration).split('.')[1];
    var beforePeriod = String(duration).substring(0, duration.indexOf('.'));
    window.newDuration = String(beforePeriod)+String(onlyFirstThree.substring(0, 3));
  }


  var afterPeriod = duration.substr(duration.indexOf(".") + 1);
  //add 0s to make sure the timing is correct, there needs to be 3 numbers after the period.
  if (duration.indexOf(".") > -1) {
      if (afterPeriod.length == 1) {
          window.newDuration = Number(window.newDuration + "00");
      } else if (afterPeriod.length === 2) {
        window.newDuration = Number(window.newDuration + "0");
      } else if (afterPeriod.length === 3) {
          window.newDuration = Number(window.newDuration + "");
      } else {
        //this was set earlier if the length was over 3
      }
  } else {
      window.newDuration = Number(window.newDuration + "000");
  }

  //reset audio marker and scrub bar
  document.getElementById("Audio_Marker").style.animation = '';
  document.getElementById("Audio_Scrub_02").style.animation = '';
  document.getElementById("Audio_Scrub_02").style.width = "1px";
  document.getElementById("Audio_Marker").style.left = "51px";
  document.getElementById("Audio_Marker").style.animation = 'none';
  document.getElementById("Audio_Scrub_02").style.animation = 'none';
  //var percent = ((audio.currentTime / audio.duration).toFixed(2) * 100).toFixed(0);
  //if (percent == 0) {
    //audio.play();
  //}

  //set animation for first screen or title screens
  var moveMarker = "";
  var moveAudioScrub = "";
  if(currentFileName=="B00010"){
    moveMarker = "moveMarkerFirst";
    moveAudioScrub = "moveAudioScrubFirst";
  }else{
    moveMarker = "moveMarker";
    moveAudioScrub = "moveAudioScrub";
  }

  //if current time is 0, then audio hasn't started. set animation
  //if (this.currentTime == 0) {
    //set animation to none to remove it, then set timeout to readd animation
    document.getElementById("Audio_Marker").style.animation = 'none';
    setTimeout(function () {
      document.getElementById("Audio_Marker").style.animation = moveMarker+' ' + window.newDuration + 'ms linear 0s 1 forwards';
    }, 25);
    
    document.getElementById("Audio_Scrub_02").style.animation = 'none';
    setTimeout(function () {
      document.getElementById("Audio_Scrub_02").style.animation = moveAudioScrub+' ' + window.newDuration + 'ms linear 0s 1 forwards';
    }, 25);
  //}

  //set variable to true, to let animate know if it can start playing, if it isn't ready yet
  window.reactAudioReady=true;
  //animate screen loaded first, play audio from react
  if(window.StartAudio==true){
    //console.log("animate screen loaded first, play audio from react");
    audio.play();

    //reset audio marker and scrub bar
    document.getElementById("Audio_Marker").style.animation = '';
    document.getElementById("Audio_Scrub_02").style.animation = '';
    document.getElementById("Audio_Scrub_02").style.width = "1px";
    document.getElementById("Audio_Marker").style.left = "51px";

    document.getElementById("Audio_Marker").classList.remove("pauseAudio");
    document.getElementById("Audio_Marker").classList.add("playAudio");
    document.getElementById("Audio_Scrub_02").classList.remove("pauseAudio");
    document.getElementById("Audio_Scrub_02").classList.add("playAudio");
    
  }else{
    //console.log("react screen loaded first, pause for now, play audio from index page");
    audio.pause();
    document.getElementById("Audio_Marker").classList.remove("playAudio");
    document.getElementById("Audio_Marker").classList.add("pauseAudio");
    document.getElementById("Audio_Scrub_02").classList.remove("playAudio");
    document.getElementById("Audio_Scrub_02").classList.add("pauseAudio");
  }

} //end addFunctionForAudio





//start loading the first screen
loadJSON(function(response) {
  var json = JSON.parse(response);
  var jsonContent = json.Screens;
  var currentFileName = "B00000";
  var loadAudio = "B00000"

  startCreating(jsonContent, currentFileName, loadAudio);
});


// WEBPACK FOOTER //
// ./src/index.js